import React from 'react';
import Add from '../../models/clients/Insert';
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import AuthService from "../../services/auth.service";

export default function AddClients() {

    const { t } = useTranslation();

    return (
        <div>
            <br />
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to={'/Home/'}>{t("Home_Breadcrumb_Title")}</Link></li>
                    <li className="breadcrumb-item"><Link to={'/Clients/'}>{t("Clients_Breadcrumb_Title")}</Link></li>
                    <li className="breadcrumb-item"><Link to={'/Clients/Add'}>{t("Clients_Add_Breadcrumb_Title")}</Link></li>
                </ol>
            </nav>
            <br />

            { AuthService.isUserAdmin() ?

                <Add />

                :

                <b>{t("Global_NotAllowed_Message")}</b>
            }

            <br />
            <br />
        </div >
    );

}
